export default __webpack_public_path__ + "static/media/girl.caa9166c.jpg";